import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  Button,
  VStack,
  Icon
} from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { FaHome } from 'react-icons/fa';

const MotionBox = motion(Box);
const MotionButton = motion(Button);

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <Box bgImage={`url(${process.env.REACT_APP_BG_URL})`} minH="calc(100vh - 200px)" display="flex" alignItems="center">
      <Container maxW="container.md" py={20}>
        <MotionBox
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <VStack spacing={6} textAlign="center">
            {/* 404 Number */}
            <Text
              fontSize={{ base: '8xl', md: '9xl' }}
              fontWeight="black"
              color="black"
              lineHeight="1"
              fontFamily="'Cormorant', serif"
            >
              404
            </Text>

            {/* Error Message */}
            <Heading
              as="h1"
              size="xl"
              color="gray.800"
              fontWeight="bold"
            >
              Page Not Found
            </Heading>

            <Text
              fontSize={{ base: 'md', md: 'lg' }}
              color="gray.600"
              maxW="500px"
            >
              Oops! The page you're looking for doesn't exist. It might have been moved or deleted.
            </Text>

            {/* Decorative Icon */}
            <Box fontSize="6xl" opacity={0.3}>
              🔍
            </Box>

            {/* Back to Home Button */}
            <MotionButton
              leftIcon={<Icon as={FaHome} />}
              bg="black"
              color="white"
              size="lg"
              px={8}
              py={6}
              fontSize="md"
              fontWeight="600"
              onClick={() => navigate('/')}
              _hover={{ bg: 'gray.800', transform: 'translateY(-2px)' }}
              _active={{ bg: 'gray.900', transform: 'translateY(0)' }}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              boxShadow="md"
            >
              Back to Home
            </MotionButton>

            {/* Additional Links */}
            <VStack spacing={2} pt={4}>
              <Text fontSize="sm" color="gray.500">
                You might want to explore:
              </Text>
              <Box>
                <Button
                  variant="link"
                  color="gray.700"
                  fontSize="sm"
                  fontWeight="medium"
                  onClick={() => navigate('/products/all')}
                  _hover={{ color: 'black', textDecoration: 'underline' }}
                  mr={4}
                >
                  Products
                </Button>
                <Button
                  variant="link"
                  color="gray.700"
                  fontSize="sm"
                  fontWeight="medium"
                  onClick={() => navigate('/about-us')}
                  _hover={{ color: 'black', textDecoration: 'underline' }}
                  mr={4}
                >
                  About Us
                </Button>
                <Button
                  variant="link"
                  color="gray.700"
                  fontSize="sm"
                  fontWeight="medium"
                  onClick={() => navigate('/contact')}
                  _hover={{ color: 'black', textDecoration: 'underline' }}
                >
                  Contact
                </Button>
              </Box>
            </VStack>
          </VStack>
        </MotionBox>
      </Container>
    </Box>
  );
};

export default NotFoundPage;
